import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
  makeStyles,
  colors
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import tokenService from '../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import services from '../Services';
import moment from 'moment';

const useStyles = makeStyles(() => ({
  root: {}
}));

const Sales = ({ className, ...rest }) => {
  const classes = useStyles();
  const theme = useTheme();

  const data = {
    datasets: [
      {
        backgroundColor: colors.indigo[500],
        data: [18, 5, 19, 27, 29, 19, 20],
        label: 'This year'
      },
      {
        backgroundColor: colors.grey[200],
        data: [11, 20, 12, 29, 30, 25, 13],
        label: 'Last year'
      }
    ],
    labels: ['1 Aug', '2 Aug', '3 Aug', '4 Aug', '5 Aug', '6 Aug']
  };

  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          barThickness: 12,
          maxBarThickness: 10,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {
            fontColor: theme.palette.text.secondary
          },
          gridLines: {
            display: false,
            drawBorder: false
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider
          }
        }
      ]
    },
    tooltips: {
      backgroundColor: theme.palette.background.default,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  const [totalCrop, setTotalCrop] = useState([]);
  const [count,setCount]= useState()

  useEffect(() => {
    trackPromise(GetDetails());
  }, []);


  async function GetDetails() {
    var thisYearvalue = [];
    var lastYearvalue = [];
    var lable = [];
    var total=0;

    let model = {
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    }
    const cropData = await services.GetLast7DaysCropDetailsforDashboard(model);

    cropData.map((object,i) => {
      if(i<=6){
        lastYearvalue.push(object.totalNetWeight);
        lable.push(moment(new Date(object.date)).format('MMM-DD')); 
        total =total+object.totalNetWeight;
      }
      else{
        thisYearvalue.push(object.totalNetWeight);
        total =total+object.totalNetWeight;
      }
    } );
 
    let data = {
      datasets: [
        {
          backgroundColor: colors.indigo[500],
          data: thisYearvalue,
          label: 'This year'
        },
        {
          backgroundColor: colors.grey[200],
          data: lastYearvalue,
          label: 'Last year'
        }
      ],
      labels: lable
    };

    setTotalCrop(data);
    setCount(total);
  }

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardHeader
        // action={(
        //   <Button
        //     endIcon={<ArrowDropDownIcon />}
        //     size="small"
        //     variant="text"
        //   >
        //     Last 7 days
        //   </Button>
        // )}
        title="Last 7 Days Crop Details"
      />
      <Divider />
      <CardContent>
        <Box
          height={400}
          display="flex"
        >
         { count!=0 ?
            <Bar
            data={totalCrop}
            options={options}
            />
            :
            <Box m="auto">
            <img src='/static/images/No-records-2.png' height={200} width={200}
            style={{ display: "block", margin: "auto" }}
            />
            </Box>
            }
        </Box>
      </CardContent>
      <Divider />
      {/* <Box
        display="flex"
        justifyContent="flex-end"
        p={2}
      >
        <Button
          color="primary"
          endIcon={<ArrowRightIcon />}
          size="small"
          variant="text"
        >
          Overview
        </Button>
      </Box> */}
    </Card>
  );
};

Sales.propTypes = {
  className: PropTypes.string
};

export default Sales;
